import { FieldValues, FieldPath, Control, RegisterOptions, Controller } from 'react-hook-form';
import { AppRadioGroupField, AppRadioGroupFieldProps } from '../fields/radioGroup/radioGroupField';

type HookFormRadioGroupFieldProps<
  TOption,
  TKey extends string | number = string | number,
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<AppRadioGroupFieldProps<TOption, TKey>, 'value' | 'onChange'> & {
  name: TName;
  control: Control<TFieldValues>;
  rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>;
  onFocus?: () => void;
  defaultValue?: unknown;
};

export function HookFormRadioGroupField<
  TOption,
  TKey extends string | number = string | number,
  TFieldValues extends FieldValues = FieldValues,
>(props: HookFormRadioGroupFieldProps<TOption, TKey, TFieldValues>) {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      // @ts-ignore
      defaultValue={props.defaultValue}
      render={({ field: { value, onChange, ref }, fieldState: { error }, formState: { isSubmitting } }) => (
        <div tabIndex={0} ref={ref}>
          <AppRadioGroupField<TOption, TKey>
            value={value}
            onChange={(selectedOption: TOption) => {
              onChange(selectedOption[props.valueField]);
            }}
            {...props}
            errorProps={{
              ...props.errorProps,
              errors: error?.message ?? props.errorProps?.errors,
            }}
            disabled={props.disabled || isSubmitting}
          />
        </div>
      )}
    />
  );
}
